import { SellersProvider } from "../../../app/contexts/SellerContex";
import { SellersPage } from "./SellersPage";

export const Sellers = () => {
  return (
    <SellersProvider>
      <SellersPage />
    </SellersProvider>
  );
};
